import meshbasicgradientmapFrag from './ShaderChunk/meshbasicgradientmap_frag.glsl';
import meshbasicgradientmapanimatedFrag from './ShaderChunk/meshbasicgradientmapanimated_frag.glsl';
import meshbasicgradientmapanimatedVert from './ShaderChunk/meshbasicgradientmapanimated_vert.glsl';
// eslint-disable-next-line camelcase
import meshtext2_frag from './ShaderChunk/meshtext2_frag.glsl';
// eslint-disable-next-line camelcase
import meshtext2_vert from './ShaderChunk/meshtext2_vert.glsl';
// eslint-disable-next-line camelcase
import meshtextwave_frag from './ShaderChunk/meshtextwave_frag.glsl';
// eslint-disable-next-line camelcase
import meshtextwave_vert from './ShaderChunk/meshtextwave_vert.glsl';
// eslint-disable-next-line camelcase
import meshtextwaveshift_vert from './ShaderChunk/meshtextwaveshift_vert.glsl';
// eslint-disable-next-line camelcase
import meshtextshift_vert from './ShaderChunk/meshtextshift_vert.glsl';

// eslint-disable-next-line camelcase
import map_gradient_map_frag from './ShaderChunk/map_gradient_map_frag.glsl';
// eslint-disable-next-line camelcase
import gradient_map_pars_frag from './ShaderChunk/gradient_map_pars_frag.glsl';
// eslint-disable-next-line camelcase
import map_gradient_map_influence_frag from './ShaderChunk/map_gradient_map_influence_frag.glsl';
// eslint-disable-next-line camelcase
import map_gradient_map_influence_animated_frag from './ShaderChunk/map_gradient_map_influence_animated_frag.glsl';
// eslint-disable-next-line camelcase
import time_pars_common from './ShaderChunk/time_pars_common.glsl';
// eslint-disable-next-line camelcase
import noise_func from './ShaderChunk/noise_func.glsl';

const THREE = require('three');

export const ShaderChunk = {
    meshbasicgradientmapFrag,
    meshbasicgradientmapanimatedVert,
    meshbasicgradientmapanimatedFrag,
    meshtext2_frag,
    meshtext2_vert,
    meshtextwave_frag,
    meshtextwave_vert,
    meshtextwaveshift_frag: meshtextwave_frag,
    meshtextwaveshift_vert,
    meshtextshift_frag: meshtextwave_frag,
    meshtextshift_vert
};

export const initShaderChunk = () => {
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.map_gradient_map_frag = map_gradient_map_frag;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.gradient_map_pars_frag = gradient_map_pars_frag;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.map_gradient_map_influence_frag = map_gradient_map_influence_frag;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.map_gradient_map_influence_animated_frag = map_gradient_map_influence_animated_frag;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.time_pars_common = time_pars_common;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.noise_func = noise_func;
};
